// firestore.rules validates media URL fields as any non-empty string, so a
// stored URL is not evidence of where it points. Anything that attaches the
// caller's ID token to one of those URLs must check the host first, or an
// internal user could harvest another user's token by pointing a media record
// at a server they control.
const STORAGE_HOSTS = new Set([
  'firebasestorage.googleapis.com',
  'storage.googleapis.com',
])

export const isFirebaseStorageUrl = (url: string): boolean => {
  try {
    return STORAGE_HOSTS.has(new URL(url).hostname)
  } catch {
    return false
  }
}
